import { render } from "./CompleteArea.vue?vue&type=template&id=507ad54a&scoped=true"
import script from "./CompleteArea.vue?vue&type=script&lang=js"
export * from "./CompleteArea.vue?vue&type=script&lang=js"

import "./CompleteArea.vue?vue&type=style&index=0&id=507ad54a&scoped=true&lang=css"

import exportComponent from "/home/hkohashi/webinar-master-php83/frontend-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-507ad54a"]])

export default __exports__